module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"search":"Buscar...","no-results":"Não foram encontrados resultados.","status":{"active":"Ativa","inactive":"Inativa"},"pagination":{"previous":"Anterior","of":"de","next":"Próximo"}},"en-US":{"search":"Search...","no-results":"No results found.","status":{"active":"Active","inactive":"Inactive"},"pagination":{"previous":"Previous","of":"of","next":"Next"}}}')
  delete Component.options._Ctor
}
